import { render, staticRenderFns } from "./ConfirmButton.vue?vue&type=template&id=88ac2c50&scoped=true&"
import script from "./ConfirmButton.vue?vue&type=script&lang=ts&"
export * from "./ConfirmButton.vue?vue&type=script&lang=ts&"
import style0 from "./ConfirmButton.vue?vue&type=style&index=0&id=88ac2c50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88ac2c50",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('88ac2c50')) {
      api.createRecord('88ac2c50', component.options)
    } else {
      api.reload('88ac2c50', component.options)
    }
    module.hot.accept("./ConfirmButton.vue?vue&type=template&id=88ac2c50&scoped=true&", function () {
      api.rerender('88ac2c50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/ConfirmButton.vue"
export default component.exports